module.exports = __webpack_public_path__ + "static/img/new-banner-gar.0c6abe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/new-banner-gar.png
// module id = J5sG
// module chunks = 44